// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';
import Hspii from '../../helper/encryption/Hspii.js';
const rsa = new Hspii();

const defaultState = {
  hasBeenStored: false,
  rsa: rsa,
  forgottenSitePassword: false,
  decryptProgress: 0,
  loading: false,
  error: null
};

export default function encryptionReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.encryption.ACTION_TYPES.KEY_STORED:
      return { ...state, hasBeenStored: true, loading: false };
    case actions.encryption.ACTION_TYPES.DECRYPT_PROGRESS:
      return { ...state, decryptProgress: action.payload };
    case actions.encryption.ACTION_TYPES.FORGOTTEN_SITE_PASSWORD:
      return { ...state, forgottenSitePassword: true, loading: false };
    case actions.encryption.ACTION_TYPES.ERROR:
      return { ...state, error: action.payload, loading: false };
    case actions.encryption.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    case actions.auth.ACTION_TYPES.LOGOUT:
      state.rsa.deletePrivateKey();
      return defaultState;
    default:
      return state;
  }
}
